var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { Dropdown } from "../Dropdown";
import { getSoilTypes } from "../../../utils/api/soiltype/data-access";
export const SoilTypeDropdown = ({ value, onChange }) => {
    const [soilTypes, setSoilTypes] = useState([]);
    const [selectedSoilType, setSelectedSoilType] = useState("");
    useEffect(() => {
        const fetchSoilTypes = () => __awaiter(void 0, void 0, void 0, function* () {
            const apiResponse = yield getSoilTypes();
            if (apiResponse.status === 200 && apiResponse.data) {
                const ddSoilTypes = apiResponse.data.map((soilType) => {
                    var _a;
                    return {
                        ID: soilType.id,
                        Name: soilType.name,
                        Description: (_a = soilType.description) !== null && _a !== void 0 ? _a : ""
                    };
                });
                setSoilTypes(ddSoilTypes);
            }
        });
        fetchSoilTypes();
    }, []);
    //================================================================================================
    // FUNCTIONS
    //================================================================================================
    const handleOnChange = (value) => {
        setSelectedSoilType(value);
        //from categories we will get a min-max values, pass them back as a number array
        if (value) {
            const selectedSoilType = soilTypes.find(soilType => soilType.ID === value);
            if (selectedSoilType) {
                onChange(selectedSoilType.ID, [selectedSoilType.Name]);
            }
            else {
                onChange(null, []);
            }
        }
        else {
            onChange(null, []);
        }
    };
    return (React.createElement(Dropdown, { items: soilTypes, displayName: "Name", displayValue: "ID", label: "Soil Type", value: selectedSoilType, onChange: handleOnChange, labelPosition: "top", disabled: false, minWidth: "150px", maxWidth: "250px" }));
};
